import { useState, useEffect } from 'react';
import { oauth as oauthClientsApi } from '@afosto/iam/api/Oauth';

const useScopes = () => {
  const [scopes, setScopes] = useState([]);
  const [isFetchingScopes, setIsFetchingScopes] = useState(true);

  useEffect(() => {
    let isMounted = true;

    /**
     * Fetches all the scopes and formats them
     * @returns {Promise}
     */
    const fetchScopes = async () => {
      try {
        setIsFetchingScopes(true);

        const response = await oauthClientsApi.getScopesList();

        const { data = [] } = response;
        const formattedScopes = Object.values(data).reduce(
          (acc, availableScope) => [
            ...acc,
            {
              value: availableScope.identifier,
              label: availableScope.identifier,
              description: availableScope.description,
            },
          ],
          [],
        );

        if (isMounted) {
          setScopes(formattedScopes);
        }
      } catch (err) {
        if (isMounted) {
          setScopes([]);
        }
      } finally {
        if (isMounted) {
          setIsFetchingScopes(false);
        }
      }
    };

    fetchScopes();

    return () => {
      isMounted = false;
    };
  }, []);

  return [scopes, isFetchingScopes];
};

export default useScopes;
